import { Injectable } from '@angular/core';
import { AssetMetadataKey } from '@gelato-api-ui/core/designs/types/asset-metadata-key.enum';
import { MetadataService } from '@gelato-api-ui/core/metadata/services/metadata.service';
import { MetadataItem } from '@gelato-api-ui/core/metadata/types/metadata-item';

@Injectable({ providedIn: 'root' })
export class AssetMetadataService {
  constructor(private readonly metadataService: MetadataService) {}

  getQuantizedColors(metadata: MetadataItem[]): string[] {
    return this.metadataService.getItemValue(metadata, AssetMetadataKey.QUANTIZED_COLORS) as string[];
  }

  getFillColors(metadata: MetadataItem[]): string[] {
    return this.metadataService.getItemValue(metadata, AssetMetadataKey.FILL_COLORS) as string[];
  }

  getStrokeColors(metadata: MetadataItem[]): string[] {
    return this.metadataService.getItemValue(metadata, AssetMetadataKey.STROKE_COLORS) as string[];
  }

  getProviderAssetId(metadata: MetadataItem[]): string {
    return this.metadataService.getItemValue(metadata, AssetMetadataKey.PROVIDER_ASSET_ID) as string;
  }
}
